import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import _ from "lodash";
import Modal from 'react-responsive-modal';

import axios from 'axios';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Select from 'react-select';
// import ReactTooltip from 'react-tooltip';

import SweetAlert from 'react-bootstrap-sweetalert';
import ComponentIndex from '../common/appendComponents';
import redirectURL from "../redirectURL"
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import $ from "jquery";
var infoBox = require('../../common/google-infowindow');
// var oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);
// var googleAnalytics = require("../common/googleanalytics");

var marker;
var markers = [];
var circle;
var selectlat;
var selectlng
var allcords = [];
var map;
var doOnce = true;
var rad = function (x) {
    return x * Math.PI / 180;
};
var rlatitude;
var rlongitude;

var fencingLength = 0;
var geoFencingArea;
var consigners = [];
export default class FOLocations extends Component {

    constructor(props) {
        super(props);
        this.displayData = [];
        this.state = {
            pageTitle: "",
            eventGridAction: "gridAction",
            eventCounterAction: "counterAction",
            eventFormAction: "formAction",
            showform: 'show-m',
            loadshow: 'show-n',
            loadshowSlider: 'show-n',
            showrefresh: 'show-n',
            sliderTranslate: '',
            showdata: this.displayData,
            radius: 10,
            rlatitude: '',
            rlongitude: '',
            latitude: '',
            longitude: '',
            defaultradius: 0,
            coordinates: [],
            alert: null,
            show: false,
            basicTitle: '',
            basicType: "default",
            contentString: "testing",
            mwidth: "col-xl-12 col-lg-12",
            dept_code: '',
            defaultColDef: {
                sortable: true,
                filter: true,
                //editable: true,
                resizable: true
            },
            rowData: [],
            zones: [],
            zone: '',
            plantOptions: [],
            allOptions:[],
            subcounterCountAll: 0,
            subcounterCountInP: 0,
            subcounterCountInT: 0,
            subcounterCountND: 0,
            originalrowData: [],
            selectedTabLat: '',
            selectedTabLng: '',
            deftab: 'all',
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: false,
            rowSelection: "single",
            context: { componentParent: this },

            loadingCellRenderer: "customLoadingCellRenderer",
            loadingCellRendererParams: { loadingMessage: "One moment please..." },
            rowModelType: "serverSide",
            paginationPageSize: 50,
            cacheBlockSize: 50,
            maxBlocksInCache: 2,

            plant_code: [],
            showPlant: 'show-n',
            showAddr: 'show-n',
            request_type: '',
            view_type: '',
            tabplants: [],
            clickabletab: '',
            plantlist: [],
            stateFormData: "",
            sliderStateEmailsTranslate: "",
            overly: "show-n",
            showStateTrucksMsg: "show-n",
            states_list: [],
            selectedState: [],
            showStates: "show-n",
            showRadius: "show-m",
            usermanualmodal: false,
            isHovered:false,
            userInputValue:"",
            searchValue:[],
            searchFoList:[]
        };
        this.popmarker = this.popmarker.bind(this);
        this.goBack = this.goBack.bind(this);
    }
    /*Alert Popups*/
    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    
  handleMouseEnter = () => {
    console.log("mouse entered")
    this.setState({isHovered: true})
  }

  handleMouseOut = () => {
    this.setState({isHovered: false})
  }

    onRecieveInput = (value) => {
        this.setState({
            alert: (
                <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
                    You wrote: {value}
                </SweetAlert>
            )
        });
    }
    hideAlert = () => {
        this.setState({
            alert: null
        });
    }
    componentDidMount() {
        var upath = window.location.pathname.split("/")
        var deptcode = "sndg";
        console.log("component did mount rendered")
        // this.setState({
        //     dept_code: deptcode,
        //     // overly: "show-m",
        //     // loadshow: "show-m"
        // });
        this.renderMapDefault();
        let query = {status:[1, 2, 3]}
        redirectURL.post("consignments/getFONumbers", query)
            .then(res => {
                if (res.status === 200) {
                    let fo_numbers = res.data.data
                    let temp = fo_numbers.map(e=>({value: e, label: e}))
                    let temp_1 = temp.slice(0, 20)
                    this.setState({plantOptions: temp_1, allOptions: temp})
                }
            })
            .catch(err => console.log(err))

        let pageTitle = "FO Locations";
        this.setState({ pageTitle: pageTitle });

    }

    handleInputChange = (inputValue) => {
        console.log(inputValue, "input_value")
        if (inputValue === ""){
            inputValue = this.state.userInputValue
        }
         
    
    // Filter options based on the input, and show the first 20 matching options
    let alldata  = this.state.allOptions
    const filteredOptions = alldata.filter(option => 
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    let temp_2 = filteredOptions.slice(0, 20)
    console.log(temp_2, "temp_2")
 
    this.setState({plantOptions:temp_2, userInputValue: inputValue}); // Limit to first 20 options
  };


  isOptionDisabled = () => {
    return this.state.plant_code.length >= 10;
  };

    renderMapDefault = () => {

        loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCbVLHDKmRETk7xp5RZzUdMYPCZe7Is59w&libraries=places,drawing&callback=initMapDefault");
        window.initMapDefault = this.initMapDefault
    }
    renderMap = () => {
        loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCbVLHDKmRETk7xp5RZzUdMYPCZe7Is59w&libraries=places,drawing&callback=initMap");
        window.initMap = this.initMap
        console.log("map rendered")
    }
    initMapDefault = () => {

        var lt = 28.4519751;
        var ln = 77.0310713;

        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
            zoom: 13,
            center: new window.google.maps.LatLng(lt, ln),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        });

        var input = document.getElementById('search');
        var searchBox = new window.google.maps.places.SearchBox(input);
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        // Bias the SearchBox results towards current map's viewport.
        map.addListener('bounds_changed', function () {

            searchBox.setBounds(map.getBounds());
        });

        var markers = [];
        //console.log("searchBox",searchBox);
        searchBox.addListener('places_changed', function () {
            var places = searchBox.getPlaces();

            if (places.length == 0) {
                return;
            }

            // Clear out the old markers.
            markers.forEach(function (marker) {
                console.log("Search Marker ", marker)
                marker.setMap(null);
            });
            markers = [];
            // For each place, get the icon, name and location.
            var bounds = new window.google.maps.LatLngBounds();
            places.forEach(function (place) {
                if (!place.geometry) {
                    console.log("Returned place contains no geometry");
                    return;
                }
                var icon = {
                    url: place.icon,
                    size: new window.google.maps.Size(71, 71),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(17, 34),
                    scaledSize: new window.google.maps.Size(25, 25)
                };

                // Create a marker for each place.
                //console.log("Plae Lat", place.geometry.location.lat());
                document.getElementById("latitude").value = place.geometry.location.lat();

                document.getElementById("longitude").value = place.geometry.location.lng();

                markers.push(new window.google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: place.name,
                    position: place.geometry.location
                }));

                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });

            map.fitBounds(bounds);
        });

        circle = new window.google.maps.Circle({
            map: map
        });

        marker = new window.google.maps.Marker({
            map: map,
            draggable: true,
            animation: window.google.maps.Animation.DROP,
            //position: {lat: 28.48, lng: 77.06}
        });

        marker.addListener('click', function () {
            marker.setAnimation(window.google.maps.Animation.BOUNCE)
        });

        window.google.maps.event.addListener(map, 'click', function (event) {

            document.getElementById("latitude").value = event.latLng.lat();
            document.getElementById("longitude").value = event.latLng.lng();
            marker.setPosition(event.latLng);

        });
        circle.bindTo('center', marker, 'position');



        var eventtrigger = document.getElementsByClassName('truck');

        // var searchBox = new window.google.maps.places.SearchBox(eventtrigger);
        //map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(eventtrigger);

    }

    toggleBounce() {
        if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
        } else {
            marker.setAnimation(window.google.maps.Animation.BOUNCE);
        }

    }

    changeInputHandler = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        // Allow only numbers and empty input
        if (/^\d*$/.test(value)) {
            this.setState({ [name]: value });
        }
    };

    onChangeFONumber = async (selectedOptions) => {
        console.log("Selected options:", selectedOptions);
        await this.setState({ plant_code: selectedOptions });
    };


    submitFormHandler(formdata) {
        var lt=28.4519751;
        var ln=77.0310713;
        rlatitude = lt;
        rlongitude = ln;
        let params = {}
        var urlpath = '/consignments/getFOLocation';
        this.setState({
            loadshowSlider: "show-m",
            // userInputValue:"",
            // plant_code:[],
            // plantOptions:this.state.allOptions.slice(0, 20)
        })
        redirectURL.post(urlpath, formdata)
            .then(
                async (response) => {
                    console.log("response", response);
                    if(response.data.status == "success") {
                        var tabplants = [];
                        var trucks_data = JSON.parse(response.data.data);
                        //allcords=[];
                        var allmarkers = response.data.trucks_data;
                        console.log("allmarkers ", trucks_data);
                        var dCode = this.state.dept_code;
                        if (trucks_data.length > 0) {
                            console.log("UPpcase Dept ");
                            var markers = [];
                            var mainlat = '';
                            var mainlng = '';
                            var maincoords = [];
                            var mlat = '';
                            var mlng = '';

                            this.setState({
                                coordinates: trucks_data,
                                mwidth: "col-xl-7 col-lg-7",
                                rowData: trucks_data,
                                originalrowData: trucks_data,
                                loadshow: 'show-n',
                                showform: 'show-n',
                                showrefresh: 'show-m',
                                rlatitude: mlat,
                                rlongitude: mlng,
                                tabplants: tabplants,
                            })


                            var coords = markers;
                            
                            // var p1 = { lat: parseFloat(formdata.latitude), lng: parseFloat(formdata.longitude) };
                            
                            console.log("allcords.length ", allcords)

                            window.initMap = await this.initMap
                            await this.renderMap();
                        }
                        else {
                            this.setState({
                                show: true, basicType: 'warning', basicTitle: "No Data found.",
                                loadshow: 'show-n',
                                showform: 'show-m',
                                plant_code:[]
                            });

                        }
                    }
                    else {
                            this.setState({
                                show: true, basicType: 'warning', basicTitle: "No Data found.",
                                loadshow: 'show-n',
                                showform: 'show-m',
                                 plant_code:[],
                                 rowData:[],
                                 mwidth: "col-xl-12 col-lg-12",
                                 ...this.renderMapDefault()
                                 
                            });

                        }
                })
            .catch(function (error) {
                console.log(error);
                this.setState({loadshowSlider: "show-n"})
            });
    }


    submitMailForm = (event) => {
        event.preventDefault();
        var emails = document.getElementById("email_ids").value;
        console.log(emails);
        try {
            if (emails.includes(",")) {
                emails = emails.replace(/\s/g, "");
                emails = emails.split(",");
            }
            else {

                emails = [emails]
            }
            var formdata = this.state.stateFormData;
            formdata['emails'] = JSON.stringify(emails);
            if ($("#gps_record_flag").prop("checked")) {
                formdata['gps_records_flag'] = 1;
            }
            else {
                formdata['gps_records_flag'] = 0;
            }
            this.submitFormHandler(formdata);
        }
        catch (e) {
            console.log(e)
        }
    }

    formHandler = (event) => {
        event.preventDefault();
        this.setState({
            loadshow: 'show-m',
            
        });
        var plantcodes = [];
        var formdata = {fo_numbers: this.state.searchFoList}
            console.log(formdata)
        // if (this.state.plant_code != undefined && this.state.plant_code != "") {
        //     if (this.state.plant_code.length > 0) {
        //         try {
        //             this.state.plant_code.forEach(item => {
        //                 plantcodes.push(item.value)
        //             })
        //             formdata["fo_numbers"]= plantcodes
        //         } catch (e) { }

        //     }
        // }
        
        var lt=28.4519751;
        var ln=77.0310713;
        rlatitude = lt;
        rlongitude = ln;
        console.log(formdata)

        this.submitFormHandler(formdata)

    }
    onCloseRouteDiv() {
        $("#email_ids").val("");
        this.setState({
            overly: "show-n",
            sliderStateEmailsTranslate: ""
        })
    }

    initMap = () => {
        try {
            var currentwindow;

            if (this.state.selectedTabLat != '' && this.state.selectedTabLng != '') {
                var lt = this.state.selectedTabLat;
                var ln = this.state.selectedTabLng;
            }
            else {
                var lt = this.state.rlatitude;
                var ln = this.state.rlongitude;
            }


            // }
            map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                zoom: 8,
                center: new window.google.maps.LatLng(lt, ln),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            });

            var input = document.getElementById('search');
            var searchBox = new window.google.maps.places.SearchBox(input);
            map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

            // Bias the SearchBox results towards current map's viewport.
            map.addListener('bounds_changed', function () {

                searchBox.setBounds(map.getBounds());
            });

            markers = this.state.rowData;
            /*SEARCH START*/
            //console.log("searchBox",searchBox);
            searchBox.addListener('places_changed', function () {
                var places = searchBox.getPlaces();

                if (places.length == 0) {
                    return;
                }

                // Clear out the old markers.
                markers.forEach(function (marker) {
                    console.log("Search Marker ", marker)
                    marker.setMap(null);
                });
                markers = [];
                // For each place, get the icon, name and location.
                var bounds = new window.google.maps.LatLngBounds();
                places.forEach(function (place) {
                    if (!place.geometry) {
                        console.log("Returned place contains no geometry");
                        return;
                    }
                    var icon = {
                        url: place.icon,
                        size: new window.google.maps.Size(71, 71),
                        origin: new window.google.maps.Point(0, 0),
                        anchor: new window.google.maps.Point(17, 34),
                        scaledSize: new window.google.maps.Size(25, 25)
                    };

                    // Create a marker for each place.
                    //console.log("Plae Lat", place.geometry.location.lat());
                    document.getElementById("latitude").value = place.geometry.location.lat();

                    document.getElementById("longitude").value = place.geometry.location.lng();

                    markers.push(new window.google.maps.Marker({
                        map: map,
                        icon: icon,
                        title: place.name,
                        position: place.geometry.location
                    }));

                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                map.fitBounds(bounds);
            });

            /*SEARCH END*/

            circle = new window.google.maps.Circle({
                map: map
            });

            marker = new window.google.maps.Marker({
                map: map,
                draggable: true,
                animation: window.google.maps.Animation.DROP,
                //position: {lat: 28.48, lng: 77.06}
            });

            marker.addListener('click', function () {
                marker.setAnimation(window.google.maps.Animation.BOUNCE)
            });

            window.google.maps.event.addListener(map, 'click', function (event) {

                document.getElementById("latitude").value = event.latLng.lat();
                document.getElementById("longitude").value = event.latLng.lng();
                marker.setPosition(event.latLng);

            });
            circle.bindTo('center', marker, 'position');
            var markerLatlng1;
            //console.log("Radius ", this.state.radius)
            //console.log("state Lat ",this.state.rlatitude)
            var bounds = new window.google.maps.LatLngBounds();
            var infowindow = new window.google.maps.InfoWindow();
            if (this.state.rlatitude != '' && this.state.rlongitude != '') {
                //var geoFencingObj = allcords;
                //console.log(parseFloat(this.state.rlatitude),parseFloat(this.state.rlongitude));
                markerLatlng1 = new window.google.maps.LatLng(this.state.rlatitude, this.state.rlongitude);
                //console.log("markerLatlng", markerLatlng1)
                circle = new window.google.maps.Circle({
                    strokeColor: '#71caab',
                    strokeOpacity: 0.7,
                    strokeWeight: 1,
                    fillColor: '#71caab',
                    fillOpacity: 0.25,
                    map: map,
                    center: markerLatlng1,
                    radius: Math.sqrt(this.state.radius) * 10000
                });


            }

            if (doOnce) {
                // initOMS();
                doOnce = false;
            }

            if (this.state.rowData.length > 0) {
                var markers = this.state.rowData.map((marker) => {
                    //console.log("marker ", marker)
                    if (marker.status == 0) {
                        var truckText = "Consignment Created";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_inside_24.png');
                    }
                    else if (marker.status == 1) {
                        var truckText = "Inside Plant";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_inside_24.png');
                    }
                    else if (marker.status == 2) {
                        var truckText = "In Transit";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_going_24.png');
                    }
                    else if (marker.status == 3) {
                        var truckText = "Near Customer";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_atdealer_24.png');
                    }
                    else if (marker.status == 3) {
                        var truckText = "Reached Customer";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_atdealer_24.png');
                    }
                    else if (marker.status == 5) {
                        var truckText = "Left Customer";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_leftdealer_24.png');
                    }
                    else if (marker.status == 6) {
                        var truckText = "Force Closed";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_return_24.png');
                    }
                    else if (marker.status == 7) {
                        var truckText = "Empty Truck Outside Plant";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_empty_24.png');
                    }
                    else {
                        var truckText = marker.truck_no;
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_na_24.png');
                    }
                    var image = require('../../assets/icons/truck_na_24.png');
                    var contentarr = []
                    var headerTitle = truckText
                    contentarr.push({ "key": "FO Number", "value": marker.fo_number });
                    contentarr.push({ "key": "Truck No", "value": marker.truck_no });
                    // contentarr.push({ "key": "Transporter Name", "value": marker.transporter_name });
                    // contentarr.push({ "key": "Distance from geofence", "value": marker.distance_from_coordinates });
                    //contentarr.push({"key":"LSP Name", "value":marker.lsp_name});
                    contentarr.push({ "key": "Address", "value": marker.last_known_address!==undefined?marker.last_known_address:""});
                    contentarr.push({ "key": "Last Packet Time", "value": marker.timestamp !== undefined && marker.timestamp !== null? getHyphenDDMMMYYYYHHMM(marker.timestamp):"" });

                    var contentString = infoBox(image, headerTitle, contentarr, '')


                    //var contentString = "Here "+marker.truck_no;
                    var infowindow = new window.google.maps.InfoWindow({
                        content: contentString
                    });

                    var markerLatlng = new window.google.maps.LatLng(parseFloat(marker.latitude), parseFloat(marker.longitude));
                    bounds.extend(new window.google.maps.LatLng(parseFloat(marker.latitude), parseFloat(marker.longitude)));

                    var image = require('../../assets/icons/truck_na_24.png');

                    /*if(marker.overspeeding_exception == 1)
                    {
                        var image =  require('../../assets/icons/truck_overspeed.png');
                    }
                    if(marker.nightdriving_exception == 1)
                    {
                        var image =  require('../../assets/icons/truck-end.png');
                    }*/

                    if (marker.status == 1) {
                        var image = require('../../assets/icons/truck_inside_24.png');
                    }
                    else if (marker.status == 2) {
                        var image = require('../../assets/icons/truck_going_24.png');
                    }
                    else if (marker.status == 3 || marker.status == 4) {
                        var image = require('../../assets/icons/truck_atdealer_24.png');
                    }
                    else if (marker.status == 5) {
                        var image = require('../../assets/icons/truck_leftdealer_24.png');
                    }
                    else if (marker.status == 6) {
                        var image = require('../../assets/icons/truck_return_24.png');
                    }
                    else if (marker.status == 7) {
                        var image = require('../../assets/icons/truck_empty_24.png');
                    }
                    else {
                        var image = require('../../assets/icons/truck_na_24.png');
                    }

                    var image = require('../../assets/icons/truck_na_24.png');
                    var mark = new window.google.maps.Marker({
                        position: markerLatlng,
                        map: map,
                        title: marker.truck_no,
                        icon: image
                    });
                    mark.addListener('click', function () {
                        infowindow.open(map, mark);
                    });
                    mark.setMap(map);
                    return mark
                });
                // var markerCluster = new MarkerClusterer(map, markers,
                // 	{imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
                const markerCluster = new MarkerClusterer({ map, markers });

            }
            var eventtrigger = document.getElementsByClassName('truck');
            console.log("this.state.selectedTabLat ", this.state.selectedTabLat)

            if (this.state.selectedTabLat != '' && this.state.selectedTabLng != '') {
                //console.log(" this.state.selectedTabLat ",parseFloat(this.state.selectedTabLat.toFixed(6)))
                //console.log(" this.state.selectedTabLng ",parseFloat(this.state.selectedTabLng.toFixed(6)))
                markerLatlng1 = new window.google.maps.LatLng(this.state.selectedTabLat, this.state.selectedTabLng);
                //console.log("markerLatlng", markerLatlng1)
                circle = new window.google.maps.Circle({
                    strokeColor: '#71caab',
                    strokeOpacity: 0.7,
                    strokeWeight: 1,
                    fillColor: '#71caab',
                    fillOpacity: 0.25,
                    map: map,
                    center: markerLatlng1,
                    radius: Math.sqrt(this.state.radius) * 8000
                });
                bounds.extend(new window.google.maps.LatLng(parseFloat(this.state.selectedTabLat), parseFloat(this.state.selectedTabLng)));
                var mainmark = new window.google.maps.Marker({
                    position: new window.google.maps.LatLng(parseFloat(this.state.selectedTabLat), parseFloat(this.state.selectedTabLng)),
                    map: map,
                    //title:item.plant_code
                });

                mainmark.setMap(map);
                map.setZoom(8);
                console.log("mainmark.getPosition() ", mainmark.getPosition())
                //	map.setCenter(mainmark.getPosition());
                //map.setZoom(10)
                //map.fitBounds(bounds)
            }
            else {
                console.log("Here")
            }

            map.fitBounds(bounds)
        }
        catch (e) {
            console.log(e);
        }



    }

    goBack() {
        this.onChangeFONumber()
        // window.location.reload();
    }
    getDistance = (p1, p2) => {
        //console.log("p1",p1);
        //console.log("p2",p2);
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.lat - p1.lat);
        var dLong = rad(p2.lng - p1.lng);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d / 1000; // returns the distance in meter
    };
    onShowInfo = (e) => {
        console.log(JSON.parse(e.target.id));
        this.setState({
            contentString: "Here Success"
        });
        var ourMarker = e.target.id;
        window.google.maps.event.trigger(ourMarker, 'click');
        var infowindow = new window.google.maps.InfoWindow({
            content: "Here Success"
        });
        infowindow.open(map, marker);

    }
    onClickHideAll() {
        $("#email_ids").val("");
        this.setState({
            overly: "show-n",
            sliderStateEmailsTranslate: "",

        })
    }
    popmarker(e) {
        console.log("OnClick Table ", e.data)
        var lat = parseFloat(e.data.latitude);
        var lng = parseFloat(e.data.longitude);
        var data = e.data;
        console.log(data)
        map.setCenter(new window.google.maps.LatLng(lat, lng));
        map.setZoom(22);
        var markerLatlng = new window.google.maps.LatLng(lat, lng);
        //var image =  require('../../assets/icons/truckblue.png');
        var image = require('../../assets/icons/truck_na_24.png');
        if (data.status == 0) {
            var truckText = "Consignment Created";
            var color = "#333333";
            var image = require('../../assets/icons/truck_inside_24.png');
        }

        else if (data.status == 1) {
            var truckText = "Inside Plant";
            var color = "#333333";
            var image = require('../../assets/icons/truck_inside_24.png');
        }
        else if (data.status == 2) {
            var truckText = "In Transit";
            var color = "#333333";
            var image = require('../../assets/icons/truck_going_24.png');
        }
        else if (data.status == 3) {
            var truckText = "Near Customer";
            var color = "#333333";
            var image = require('../../assets/icons/truck_atdealer_24.png');
        }
        else if (data.status == 4) {
            var truckText = "Reached Customer";
            var color = "#333333";
            var image = require('../../assets/icons/truck_atdealer_24.png');
        }
        else if (data.status == 5) {
            var truckText = "Left Customer";
            var color = "#333333";
            var image = require('../../assets/icons/truck_leftdealer_24.png');
        }
        else if (data.status == 6) {
            var truckText = "Force Closed";
            var color = "#333333";
            var image = require('../../assets/icons/truck_return_24.png');
        }
        else if (data.status == 7) {
            var truckText = "Empty Truck Outside Plant";
            var color = "#333333"; var image = require('../../assets/icons/truck_na_24.png');
            var image = require('../../assets/icons/truck_empty_24.png');
        }
        else {
            var truckText = data.truck_no;
            var color = "#333333";
            var image = require('../../assets/icons/truck_na_24.png');
        }
        var image = require('../../assets/icons/truck_na_24.png');
        var marker = new window.google.maps.Marker({
            position: markerLatlng,
            map: map,
            title: data.truck_no,
            icon: image
        });


        var contentarr = []
        var headerTitle = truckText
        contentarr.push({ "key": "Truck No", "value": data.truck_no });
        contentarr.push({ "key": "Transporter Name", "value": data.transporter_name });
        // contentarr.push({ "key": "Distance from geofence", "value": data.distance_from_coordinates });
        //contentarr.push({"key":"LSP Name", "value":data.lsp_name});
        contentarr.push({ "key": "Address", "value": data.last_known_address});
        contentarr.push({ "key": "Last Packet Time", "value": data.timestamp !== undefined && data.timestamp !== null? getHyphenDDMMMYYYYHHMM(data.timestamp):"" });

        var contentString = infoBox(image, headerTitle, contentarr, '')
        var infowindow = new window.google.maps.InfoWindow({
            content: contentString
        });

        marker.setAnimation(window.google.maps.Animation.DROP)
        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });

        marker.setMap(map);


    }

    oncellClick = (params)=>{
        console.log("cell click", params)
        if (params.data.status === 8  || params.data.status === 6 || params.data.status === 5 || params.data.status === 4 ) {
            return undefined
        }
        return this.popmarker(params)

    }
    onShowUploadDiv = () => {
        //console.log("Click Upload Button")
        this.setState({
            uploadDivWidth: '30%',
            sliderTranslate: "slider-translate",
            showDiv: 'show-m',
            csvmessage: '',
            csverrmessage: '',
        });
    }
    onCloseUploadDiv = () => {
        this.setState({
            uploadDivWidth: '0%',
            sliderTranslate: "",
            showDiv: 'show-n',
            uploadFile: '',
            file: '',
            csvmessage: '',
            csverrmessage: '',
        });
    }
    /*Truck Sidebar Component Starts*/
    async onShowSidebarAquireComponent(e) {
        this.setState({
            sliderTranslate: 'slider-translate',
            loadshow: 'show-m'
        });
        //console.log(e);
        if (e.colDef.field == 'truck_no') {
            let ComponentInfo = ComponentIndex['truck'];
            //console.log("ComponentInfo", ComponentInfo);
            var layoutdata1 = {
                truck_no: e.data[e.colDef.field]
            };
            //console.log("layoutdata",layoutdata);
            await redirectURL.post('/masters/truckByNo', layoutdata1)
                .then((response) => {
                    //console.log("trucks response", response);
                    var truckrecords = JSON.parse(JSON.stringify(response)).data;

                    this.setState({
                        truckInfo: truckrecords
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Trucks details by Truck No*/
            await redirectURL.post('/consignments/latestConsignmentsByTruckNo', layoutdata1)
                .then((response) => {
                    //console.log(response);
                    var consignrecords = JSON.parse(JSON.stringify(response)).data;

                    this.setState({
                        consignments: consignrecords
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Trucks details by Truck No*/
            await redirectURL.post('/consignments/latestTruckLocation', layoutdata1)
                .then((response) => {
                    //console.log("HR55W4880",response);
                    var currenttrucklocation = JSON.parse(JSON.stringify(response)).data;

                    this.setState({
                        currenttrucklocation: currenttrucklocation
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            //console.log("currenttrucklocation",this.state.currenttrucklocation);
            //setTimeout(function(){})

            this.displayData = await (<ComponentInfo context={this} truckNo={e.data[e.colDef.field]} truckInfo={this.state.truckInfo} consignments={this.state.consignments} currenttrucklocation={this.state.currenttrucklocation}></ComponentInfo>);
            /*		
            this.setState({
                showdata : this.displayData,
                sliderTranslate:"slider-translate"
            });
            */

            this.setState({
                showdata: this.displayData,
                loadshow: 'show-n'
            });
        }

        /*Transporters Sidebar*/

        if (e.colDef.field == 'transporter_name') {
            let ComponentInfo = ComponentIndex['transporter'];
            //console.log("ComponentInfo", ComponentInfo);
            var layoutdata1 = {
                transporter_name: e.data[e.colDef.field]
            };
            //console.log("layoutdata",layoutdata);
            await redirectURL.post('/consignments/transporterByName', layoutdata1)
                .then((response) => {
                    console.log("transporterByName response", response);
                    var transporterrecords = JSON.parse(JSON.stringify(response)).data;
                    var deptcodes = [];
                    var transportName = '';
                    var transportCode = '';
                    transporterrecords.map(item => {
                        transportName = item.transporter_name;
                        transportCode = item.transporter_code;
                        deptcodes.push(item.dept_code + ", ");
                    });
                    //console.log(transportName+","+transportCode+","+deptcodes)
                    var transportData = [{
                        transporter_name: transportName,
                        transporter_code: transportCode,
                        dept_code: deptcodes
                    }]
                    this.setState({
                        transporterInfo: transportData
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Total Trucks Operating*/
            await redirectURL.post('/consignments/totalTrucksOperating', layoutdata1)
                .then((response) => {
                    //console.log("Total Trucks Operating response", response);
                    this.setState({
                        truckoperates: response
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Total Trucks With GPS Integration Lifetime*/
            await redirectURL.post('/consignments/totalTrucksGPSLifetime', layoutdata1)
                .then((response) => {
                    console.log("Total Trucks Operating response", response);
                    this.setState({
                        truckgpslifetime: response
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Total Trucks With GPS Integration Today*/
            await redirectURL.post('/consignments/totalTrucksGPSToday', layoutdata1)
                .then((response) => {
                    //console.log("Total Trucks Operating response", response);
                    this.setState({
                        gpstoday: response
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            /*Transporters Consignment details*/
            await redirectURL.post('/consignments/latestConsignmentsByTransporterName', layoutdata1)
                .then((response) => {
                    //console.log(response);
                    var consignrecords = JSON.parse(JSON.stringify(response)).data;
                    var consignrecordslist = [];
                    consignrecords.map(item => {
                        if (item.consigns.length > 0) {
                            item.consigns.map(cons => {
                                consignrecordslist.push(cons)
                            })

                        }
                    });

                    console.log("consignrecords list", consignrecordslist);
                    this.setState({
                        consignments: consignrecordslist
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });


            this.displayData = await (<ComponentInfo context={this} gpstoday={this.state.gpstoday} gpsLifetime={this.state.truckgpslifetime} transportName={e.data[e.colDef.field]} transporterInfo={this.state.transporterInfo} totalTruckOperating={this.state.truckoperates} consignments={this.state.consignments} ></ComponentInfo>);

            this.setState({
                showdata: this.displayData,
                loadshow: 'show-n'
            });
        }
        /*End*/

        /*LSP Sidebar*/

        if (e.colDef.field == 'actual_lspuser') {
            let ComponentInfo = ComponentIndex['lsp'];
            //console.log("ComponentInfo", ComponentInfo);
            var layoutdata2 = {
                actual_lspuser: e.data[e.colDef.field]
            };
            console.log("layoutdata2", layoutdata2);
            //Total Trucks Integrate;
            await redirectURL.post('/consignments/totalTruckIntegrate', layoutdata2)
                .then((response) => {
                    var lsprecords = JSON.parse(JSON.stringify(response)).data.count;
                    //console.log("LSP response serveeeee", lsprecords);

                    var result = lsprecords.reduce(function (sum, item) {
                        return sum = sum + item.count;
                    }, 0);
                    console.log("result", result);
                    this.setState({
                        lspInfo: result
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            this.displayData = await (<ComponentInfo context={this} nopetransporters={this.state.nopetransporters} gpssendtoday={this.state.gpssendtoday} transportersServes={this.state.transrecordserves} deptServes={this.state.deptServes} lspName={e.data[e.colDef.field]} lspInfo={this.state.lspInfo} ></ComponentInfo>);
            /*		
            this.setState({
                showdata : this.displayData,
                sliderTranslate:"slider-translate"
            });
            */

            this.setState({
                showdata: this.displayData,
                loadshow: 'show-n'
            });

        }
        /*End*/
    }
    onGridReady = params => {
        this.gridApi = params.api;

        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;

    };

    onClickShowMap = async (tabcode) => {
        console.log("tabcode ", tabcode)
        var dataarray = [];
        let subcounterCountInP = 0
        let subcounterCountInT = 0
        let subcounterCountND = 0
        if (tabcode != 'all') {
            await this.state.originalrowData.map((item) => {
                if (item.plant_code == tabcode.plant_code) {
                    dataarray.push(item);
                }
            });
            dataarray.forEach(item => {
                if (item.status == 1)
                    subcounterCountInP++
                if (item.status == 2)
                    subcounterCountInT++
                if (item.status == 3 || item.status == 4)
                    subcounterCountND++
            })
            await this.setState({
                rowData: dataarray,
                selectedTabLat: tabcode.lat,
                selectedTabLng: tabcode.lng,
                deftab: tabcode.plant_code,
                countertab: "all",
                subcounterCountAll: dataarray.length,
                subcounterCountInP,
                subcounterCountInT,
                subcounterCountND,
            });

            this.gridColumnApi.setColumnsVisible(["plant_code"], false);

        }
        else {
            this.state.originalrowData.forEach(item => {
                if (item.status == 1)
                    subcounterCountInP++
                if (item.status == 2)
                    subcounterCountInT++
                if (item.status == 3 || item.status == 4)
                    subcounterCountND++
            })
            await this.setState({
                rowData: this.state.originalrowData,
                selectedTabLat: "",
                selectedTabLng: "",
                deftab: "all",
                subcounterCountAll: this.state.originalrowData.length,
                subcounterCountInP,
                subcounterCountInT,
                subcounterCountND,
            });
            this.gridColumnApi.setColumnsVisible(["plant_code"], true);

        }
        //window.initMap = await this.initMap
        await this.renderMap();

    }
    onCloseUserManualModal = () => {
        this.setState({ usermanualmodal: false });
    };

    onClickShowUserManaul = () => {
        this.setState({ usermanualmodal: true });
    };

    handleChange = (e) => {
        const raw = e.target.value;
        const setOfFos = raw
          .split(/[\s,]+/) 
          .map(item => item.trim())        // Remove extra spaces
          .filter(item => item.length);    // Remove empty entries
        if (setOfFos.length>10){
            this.setState({ searchValue: raw, show: true, basicType: 'warning', basicTitle: "A maximum of 10 FOs can be selected at once.",
        })}
        else{
        this.setState({searchValue: raw, searchFoList: setOfFos})
        }
      };
    
    getRowStyle = (params) => {
        if (params.data.status === 8  || params.data.status === 6 || params.data.status === 5 || params.data.status === 4 ) {
            return { backgroundColor: "#ff90a3" }
        }
        return undefined
    };

    resetSearch = ()=>{
        this.setState({
                                searchValue: [],
                                rowData:[],
                                 mwidth: "col-xl-12 col-lg-12",
                                 ...this.renderMapDefault()
                                 
                            });
    }
    
    render() {
        const modalStyles = {
            width: '1300px !important',
        }

        const { usermanualmodal } = this.state;
        if (this.state.request_type == 2) {
            var showonlysnd = (this.state.dept_code == 'SNDG' || this.state.dept_code == 'sndg') ? false : true;
            var showonlyprt = (this.state.dept_code == 'LOG-PRT' || this.state.dept_code == 'log-prt') ? false : true;
            var hidecol = false;
        }
        else {
            var showonlysnd = true;
            var showonlyprt = true;
            var hidecol = true;
        }
        console.log("dept_code ", this.state.dept_code)
        console.log("request_type ", this.state.request_type)
        console.log("showonlyprt ", showonlyprt)
        var hideDistance = (this.state.view_type == "within_states") ? true : false;
        var columnDefs = [
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 140,
            },
            {
                headerName: "Truck No",
                field: "truck_no",
                width: 140,
            },
            {
                headerName: "Last Packet Time",
                field: "timestamp",
                width: 150,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.timestamp)
                }

            },

            {
                headerName: "Last Known Address",
                field: "last_known_address",
                width: 140,
            },

             {
                headerName: "Last Known City",
                field: "city",
                width: 130
            },
            {
                headerName: "State",
                field: "state",
                width: 120
            },
            
            {
                headerName: "LSP Name",
                field: "transporter_name",
                width: 200,

            },
            {
                headerName: "Status",
                field: "row_status",
                width: 120,
            },
            {
                headerName: "Tracking Mode",
                field: "tracking_mode",
                width: 120
            },
            

            // {
            //     headerName: "Consignee State",
            //     field: "consignee_state",
            //     width: 140,
            //     hide: hidecol
            // }
        ];

        const dStyles = {
            width: '90%',
            marginLeft: '0px',
            paddingLeft: '0px',
            height: '500px'
        }
        const btstye = {
            marginBottom: "10px"
        }

        return (

            <div className="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {this.state.alert}
                {/* <h5 className="mb-15p fbold f16">
                    <i className="icon-map cus-i"></i> <span style={{ fontWeight: "600" }}>{this.state.pageTitle}</span>
                </h5> */}
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-body row">
                                <form className={" theme-form col-xl-12 col-lg-12 ml-0"} onSubmit={this.formHandler}>
                                        <div className='d-flex flex-row'>
                                            <div className={"form-group col-xl-3 col-lg-3 " }>
                                                <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap", gap: "8px" }}>
                                                    <label className="c-lbl reason" style={{fontSize:"16px"}}>Select FO Number<span className='mandatory_field'>*</span></label>
                                                        {/* {this.state.isHovered?<h6 style={{fontSize:"12px", marginTop:"2px"}}> <span> A maximum of 10 FOs can be selected at once.</span></h6>:""} */}
                                                </div>

                                                <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={this.state.searchValue} onChange={this.handleChange} required />
                                                {/* {errors && (<p style={{ color: 'red', marginTop: '5px' }}>{errorMessage}</p>)} */}
														
                                                        {/* <ReactTooltip place="right" type="dark" effect="solid" /> */}
														{/* <Select
															closeMenuOnSelect={false}
															name="plant_code" isMulti={true}
															placeholder="Select FO"
															value={this.state.plant_code}
															onChange={this.onChangeFONumber}
															options={this.state.plantOptions} 
                                                            onInputChange={this.handleInputChange}
                                                            isOptionDisabled={this.isOptionDisabled}
                                                            required/> */}
													</div>
                                        <div className="form-group col-xl-4 col-lg-4 ml-0">
                                            <button type="submit" style={{ marginTop: "35px" }} className={"btn btn-success "}>Submit</button>
                                            <button type="button" className="btn btn-warning"  style={{ marginTop: "35px", marginLeft:"10px"}}  onClick={this.resetSearch}>Reset</button>
                                        </div>
                                        </div>
                                </form>
                                {this.state.rowData.length > 0 ? (<div className="row col-xl-12 col-lg-12">
                                    <div className="col-xl-12 col-lg-12 d-flex justify-content-end">
                                        <button type="button" className="btn d-inline-flex align-items-center mybtn">
                                            <i className="fa fa-circle" style={{ fontSize: "20px", color: "#ff90a3" }}></i>
                                            &nbsp;&nbsp;InActive Consignments</button></div></div>) : ("")}
                                <div className="row col-xl-12 col-lg-12">

                                    {/* <div className={"dataLoadpage " + (this.state.loadshow)}>
                                    </div>
                                    <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                                        <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                                    </div> */}
                                    {/* <input type="text" name="search" className="col-xl-6 col-lg-6 form-control mt-5p" style={{ marginTop: "12px", height: "37px" }} id="search" placeholder="Enter Address to search" /> */}
                                     {console.log(this.state.mwidth, "mwidth")}

                                    <div id="map_canvas" className={this.state.mwidth} style={dStyles}></div>
                                    {/* <input type="text" name="search" className="col-xl-6 col-lg-6 form-control mt-5p" style={{ marginTop: "12px", height: "37px" }} id="search" placeholder="Enter Address to search" /> */}
                                    {

                                        (this.state.rowData.length > 0) ?
                                            <div className="col-xl-5 col-lg-5 sidediv">

                                                <div id="myGrid" style={{ height: "500px", width: "100%" }} className="ag-theme-balham">
                                                    <AgGridReact
                                                        columnDefs={columnDefs}
                                                        defaultColDef={this.state.defaultColDef}
                                                        rowData={this.state.rowData}
                                                        enableCharts={false}
                                                        enableRangeSelection={false}
                                                        autoGroupColumnDef={this.state.autoGroupColumnDef}
                                                        onGridReady={this.onGridReady}
                                                        onGridState={this.onGridState}
                                                        statusBar={this.state.statusBar}
                                                        sideBar={this.state.sideBar}
                                                        paginationPageSize={this.state.paginationPageSize}
                                                        pagination={true}
                                                        // enableRangeSelection={false}
                                                        floatingFilter={false}
                                                        //onCellDoubleClicked={this.onShowSidebarAquireComponent.bind(this)}
                                                        onCellClicked={this.oncellClick}
                                                        getRowStyle={this.getRowStyle}
                                                    />
                                                </div>
                                            </div>
                                            : ""
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={"slide-r " + (this.state.sliderTranslate)} >


                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                        </div>
                        <div className="col-xl-12 col-lg-12">
                            {this.displayData}
                        </div>
                    </div>
                </div>

                <div className={"slide-r " + (this.state.sliderStateEmailsTranslate)} >
                    <div className="slide-r-title">
                        <h4>
                            Near By State
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onCloseRouteDiv.bind(this)} >X</span>

                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="col-xl-12 col-lg-12">
                            <form className={" theme-form col-xl-12 col-lg-12 "} onSubmit={this.submitMailForm}>
                                <div className="form-group  col-xl-12 col-lg-12">
                                    <label className="c-lbl">Email *:</label>
                                    <textarea className="form-control" id="email_ids" placeholder="Enter multiple e-mail addresses separated by comma" required></textarea>
                                </div>
                                <button type="submit" class="btn btn-info">Submit</button>
                            </form>
                        </div>
                        <div className="form-group mt-20p">
                            <p style={{ color: "#ff0000" }}>* Note: This is an E-Mail report and will be sent to the E-Mails Provided</p>

                        </div>
                    </div>
                    <div className={"dataLoadpage " + (this.state.loadshowSlider)}>
                    </div>
                    <div className={"dataLoadpageimg " + (this.state.loadshowSlider)}>
                        <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                    </div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}


function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
